import { z } from 'zod';

export const DonateSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  phoneNumber: z.string().optional(),
  zipCode: z.string().min(1, 'ZIP code is required'),
  donationAmount: z.string().min(1, 'Donation amount is required'),
  message: z.string().optional(),
})